export default __webpack_public_path__ + "static/media/1974.dec3b940.jpg";